import React from 'react';
import { formatDateTime } from '../../utils/helpers';

export const ReviewChannelRow = ({ channel, label, data, available, blocked, onSend, onCancel }) => {
  const status = data?.status || 'loading';
  const text = !available ? `${label} not on file` : ({
    sent: 'Sent', sending: 'Sending…', scheduled: 'Scheduled', failed: 'Failed — retry', not_sent: 'Not sent', loading: 'Checking…',
  }[status]);
  const when = status === 'scheduled' ? data.scheduled_for : status === 'sent' ? data?.sent_at : null;
  return (
    <div className="flex min-w-0 items-center justify-between gap-3 py-2" data-testid={`review-${channel}-row`}>
      <div className="min-w-0 text-sm">
        <span className="font-medium text-gray-800">{label}</span>
        <div data-testid={`review-${channel}-status`} data-status={status} title={data?.error || ''}
          className={`text-xs [overflow-wrap:anywhere] ${status === 'failed' ? 'text-red-700' : status === 'sent' ? 'text-green-700' : 'text-gray-500'}`}>
          {text}{when && <> · <time data-testid={`review-${channel}-timestamp`} dateTime={when}>{formatDateTime(when)}</time></>}
        </div>
      </div>
      {status === 'scheduled' && onCancel ? (
        <button type="button" onClick={() => onCancel(data.communication_id)} disabled={blocked}
          data-testid="review-sms-cancel-schedule" title="Cancel scheduled review SMS" aria-label="Cancel scheduled review SMS"
          className="shrink-0 min-w-[44px] min-h-[44px] border border-gray-300 rounded-lg text-gray-600 hover:bg-white transition-colors">✕</button>
      ) : (
        <button type="button" onClick={onSend}
          disabled={blocked || !available || ['sent', 'sending', 'scheduled'].includes(status)}
          title={!available ? `No ${channel === 'sms' ? 'phone number' : 'email address'} recorded` : status === 'sent' ? `${label} already sent` : `Preview ${label.toLowerCase()}`}
          data-testid={`workflow-send-review-${channel}-btn`}
          className="shrink-0 min-h-[44px] px-3 py-2 text-xs font-medium text-teal-800 border border-teal-300 rounded-lg hover:bg-teal-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          {status === 'loading' ? 'Checking…' : status === 'sent' ? '✓ Sent' : status === 'sending' ? 'Sending…' : status === 'failed' ? `Retry ${label}` : `Send ${label}`}
        </button>
      )}
    </div>
  );
};